export default "__VITE_ASSET__43f72eb4__"